import { EmailDeliveryService } from "./email-delivery.service";
import { EmailDeliveryStatus } from "./email-delivery.type";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { catchError, EMPTY, mergeMap } from "rxjs";
import { Router } from "@angular/router";

@Component({
    selector: "email-delivery",
    templateUrl: 'email-delivery.component.html',
    providers: [
        EmailDeliveryService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmailDeliveryComponent {

    constructor(
        private logger: LoggerService,
        private router: Router,
        private emailDeliveryService: EmailDeliveryService
        ) {}

    start() {
        this.emailDeliveryService.startTroubleshooting().pipe(
            mergeMap((start: EmailDeliveryStatus) => {
                return this.router.navigate(['setup/troubleshoot/email', start.teamMemberId]);
            }),
            catchError((error: string) => {
                this.logger.error(error);
                return EMPTY;
            })
        ).subscribe();
    }
}